/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import react, { useEffect, useRef, type JSX } from "react";
import "./NotificationPopup.css";
import closeLogo from '../../../../public/images/Close.png'

interface NotificationPopupProps {

    isModelOpen: boolean,
    setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>
    popUpContentData: { header: string, body: string, url?: string }[]


}

const NotificationPopup: React.FC<NotificationPopupProps> = (props) => {

    const { isModelOpen, setIsModalOpen , popUpContentData} = props;

    const wrapperRef = useRef<HTMLDivElement>(null);
    const containerRef = useRef<HTMLParagraphElement>(null);


    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
                setIsModalOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);


    const getPopUpContent = () => {
        return popUpContentData.map((item, index) => (
            <div key={index} className="popup-content-block">
                <h1 className="popup-header">{item.header}</h1>
                {/* <p className="popup-body" >{item.body}</p> */}
                <p className="popup-body" dangerouslySetInnerHTML={{ __html: item.body }}></p>
                {item.url && (
                    <div
                        className="popup-url"
                        dangerouslySetInnerHTML={{ __html: item.url }}
                    />
                )}
            </div>
        ));
    };


    const closePopup = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            {isModelOpen && (
                <div className="popup-select-box-login" ref={wrapperRef}>
                    {getPopUpContent()}
                    <button onClick={closePopup} aria-label="Close popup" className="close-button">
                            <img src={closeLogo} alt="" className="close-icon" />
                    </button>
                </div>
            )}
        </>
    );
}

export default NotificationPopup;